(function () {
  'use strict';
  var cache = new Map(), started = new WeakSet(), queue = [], active = 0;
  function pump() {
    while (active < 3 && queue.length) {
      active++;
      var task = queue.shift();
      task().finally(function () { active--; pump(); });
    }
  }
  function count(url) {
    var saved = cache.get(url);
    if (saved && Date.now() - saved.at < 30000) return saved.promise;
    var promise = new Promise(function (resolve) {
      queue.push(function () {
        return fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(10000) })
          .then(function (response) { if (!response.ok) throw new Error('count'); return response.json(); })
          .then(function (data) {
            if (data.schema !== 'lnw-search-count-1' || !Number.isInteger(data.count) || data.count < 0) throw new Error('count schema');
            resolve(data.count);
          }).catch(function () { cache.delete(url); resolve(null); });
      });
      pump();
    });
    cache.set(url, { at: Date.now(), promise: promise });
    return promise;
  }
  function sync(scope) {
    var nodes = Array.from(scope.querySelectorAll('[data-lnw-count-url]')).filter(function (node) { return !started.has(node); });
    nodes.sort(function (a, b) { return a.getBoundingClientRect().top - b.getBoundingClientRect().top; });
    var pageUrl = location.href;
    nodes.forEach(function (node) {
      started.add(node);
      var url = new URL(node.dataset.lnwCountUrl, location.href);
      url.searchParams.delete('page'); url.searchParams.delete('section_id');
      url.searchParams.set('view', 'lnw-count');
      var preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      node.dataset.lnwCountState = 'loading';
      count(url.href).then(function (value) {
        if (!node.isConnected || location.href !== pageUrl) return;
        if (value !== null) { node.textContent = String(value); node.style.visibility = ''; }
        else node.style.visibility = 'hidden';
        node.dataset.lnwCountState = value === null ? 'error' : 'ready';
        node.removeAttribute('aria-busy');
      });
    });
  }
  function start() {
    var main = document.getElementById('site-main');
    if (!main) return;
    sync(main);
    var scheduled = false;
    new MutationObserver(function (records) {
      var relevant = records.some(function (record) {
        return Array.from(record.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches('[data-lnw-count-url]') || node.querySelector('[data-lnw-count-url]'));
        });
      });
      if (!relevant || scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; sync(main); });
    }).observe(main, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function () { sync(main); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
}());
